module.exports = __webpack_public_path__ + "static/media/email.2df4bd82.png";